var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCst({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 22.7502C4.66675 21.9766 4.97404 21.2347 5.52102 20.6878C6.068 20.1408 6.80987 19.8335 7.58341 19.8335H23.3334",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58341 2.3335H23.3334V25.6668H7.58341C6.80987 25.6668 6.068 25.3595 5.52102 24.8126C4.97404 24.2656 4.66675 23.5237 4.66675 22.7502V5.25016C4.66675 4.47661 4.97404 3.73475 5.52102 3.18777C6.068 2.64079 6.80987 2.3335 7.58341 2.3335V2.3335Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCst);
export default __webpack_public_path__ + "static/media/cst.e839d4cac4120c0df56da9c53b2074f7.svg";
export { ForwardRef as ReactComponent };